export function routeToQuestionnairePage(
  questionnaireShownInstructionsFlag: boolean,
  questionnaireShownTermsAndConditionsFlag: boolean
): string {
  try {
    if (!questionnaireShownInstructionsFlag) {
      return '/dashboard/questionnaires/introduction'
    } else if (!questionnaireShownTermsAndConditionsFlag) {
      return '/dashboard/questionnaires/terms'
    } else {
      return '/dashboard/questionnaires'
    }
  } catch (error) {
    console.log(error)
  }
  return '/dashboard/case'
}
